var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPersonalConnection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.92606 13.7702L9.79153 13.8926C6.97755 17.7123 7.55563 24.2732 10.9841 27.5545C14.4074 30.8384 20.3038 31.0982 24.0019 28.1277C27.6999 25.1572 28.7305 18.4889 26.2646 14.4362C25.5864 17.1299 23.9503 20.1322 21.4942 21.4274C19.0405 22.7205 16.0992 22.385 13.7069 20.9794C11.3119 19.5738 9.49778 16.5128 9.92606 13.7702Z",
    fill: "#E1DEF8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8611 10.2165C24.1356 9.88327 24.4145 9.52583 24.4563 9.08767C24.4832 8.8038 24.1624 8.61053 23.9137 8.67642C23.5074 8.78624 23.1862 9.15357 22.9073 9.455C22.6113 9.77292 22.3077 10.0941 22.0062 10.4098L21.9959 10.4206C21.4217 11.0193 20.8496 11.6158 20.2579 12.2025C19.7045 12.751 19.1362 13.2776 18.5608 13.7992C18.2621 14.071 17.802 14.071 17.5006 13.7992C16.9252 13.2776 16.3569 12.7489 15.8034 12.2025C15.2087 11.6123 14.6305 11.0149 14.0551 10.4098C13.7542 10.0969 13.4506 9.77565 13.1541 9.455C12.8752 9.15136 12.554 8.78678 12.1476 8.67642C11.9028 8.61273 11.5821 8.80381 11.609 9.08767C11.6507 9.52581 11.9297 9.88326 12.2042 10.2165C12.4837 10.5542 12.7703 10.8897 13.0591 11.223C13.622 11.8693 14.2073 12.4913 14.8074 13.1036C15.5081 13.8284 16.2207 14.546 16.9576 15.2318C17.1415 15.4037 17.3249 15.575 17.511 15.7413C17.8048 16.006 18.2578 16.006 18.5543 15.7413C18.7404 15.5722 18.9243 15.4031 19.1077 15.2318C19.8451 14.5432 20.5573 13.8261 21.2579 13.1036C21.8575 12.4891 22.4428 11.867 23.0062 11.223C23.2928 10.8897 23.5821 10.5542 23.8611 10.2165Z",
    fill: "url(#paint0_linear_492_19044)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8522 7.61397C21.1339 7.27081 21.4156 6.92545 21.6973 6.58283C21.9888 6.22758 22.4051 5.78943 22.2695 5.29252C22.2157 5.11132 22.0685 5.03061 21.8923 5.0059C21.3657 4.93452 20.9347 5.52751 20.614 5.87013C20.2714 6.23746 19.9233 6.60038 19.5856 6.96991C19.0689 7.53274 18.5572 8.09884 18.0427 8.66437C17.5281 8.09878 17.0164 7.53325 16.4997 6.96991C16.1593 6.59984 15.8139 6.23526 15.4713 5.87013C15.1507 5.52751 14.7196 4.93507 14.1931 5.0059C14.0168 5.03061 13.8675 5.11132 13.8159 5.29252C13.6737 5.78943 14.0899 6.22538 14.3814 6.58283C14.6631 6.926 14.9448 7.27135 15.2264 7.61397C15.7772 8.28995 16.3455 8.95102 16.9088 9.61978C17.1509 9.90584 17.4205 10.2831 17.7681 10.4203H17.7725C17.8312 10.4423 17.8949 10.4571 17.9586 10.4642C17.9855 10.467 18.0124 10.4692 18.0393 10.4692C18.0662 10.4692 18.0931 10.4664 18.12 10.4642C18.1837 10.4571 18.2474 10.4423 18.3062 10.4203H18.3106C18.6581 10.2836 18.9299 9.9064 19.1699 9.61978C19.7305 8.95369 20.2988 8.28988 20.8522 7.61397Z",
    fill: "url(#paint1_linear_492_19044)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_492_19044",
    x1: 10.7721,
    y1: 18.1227,
    x2: 25.26,
    y2: 9.22344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_492_19044",
    x1: 13.234,
    y1: 12.1099,
    x2: 23.4541,
    y2: 6.57973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalConnection);
export default __webpack_public_path__ + "static/media/personal-connection.4b79818cad430f07493baff09d531b50.svg";
export { ForwardRef as ReactComponent };